<app-contact-documents [contact]="contact"></app-contact-documents>
<app-contact-editor [contact]="contact"></app-contact-editor>